
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from "vuex-class";
import { delMerchantsGroup, getMerchantsGroupList, GroupListDto } from "@/api/customerManage";

@Component({
  name: 'GroupSetting'
})
export default class GroupSetting extends Vue {
  groupList: GroupListDto[] = []

  created () {
    this.getGroupList()
  }

  getGroupList () {
    getMerchantsGroupList({}).then((res) => {
      this.groupList = res.data.groupList || []
    })
  }

  beforeClose ({ position, instance }) {
    switch (position) {
      case 'cell':
        break;
      case 'outside':
        instance.close();
        break;
    }
  }

  toAdd () {
    this.$router.push('/groupHandle')
  }

  delData (id: string) {
    this.$confirmDialog.show({
      okText: "确认",
      cancelText: "取消",
      tips: "删除此标签后，已标记此分组的客户将被移除分组",
      onOk: () => {
        return this.delFunc(id);
      },
    });
  }

  delFunc (id: string) {
    const params = {
      groupId: id
    }
    delMerchantsGroup(params).then(() => {
      this.$toast.success({
        message: '客户分组删除成功！',
        duration: 1000,
        onClose: () => {
          setTimeout(()=>{
            this.getGroupList()
          },200)
        }
      })
    })
  }

  toEdit (e: any, data: GroupListDto) {
    if (['setting-title','label-style','setting-list'].includes(e.target.className)) {
      this.$router.push({
        path: '/groupHandle',
        query: {
          op: 'edit',
          data: JSON.stringify(data)
        }
      })
    }
  }
}
